import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import styles from './Topbar.module.css'
import { Button } from '../ui/Button'
import { useAuth } from '../../auth/AuthContext'
import { toast } from '../../store/toastStore'
import { NotificationsDropdown } from '../../modules/notifications/NotificationsDropdown'
import { BrandMark } from './BrandMark'
import { settingsApi } from '../../api/settings.api'

export function Topbar() {
  const { logout } = useAuth()
  const navigate = useNavigate()
  const { data: settings } = useQuery({
    queryKey: ['settings', 'general'],
    queryFn: async () => (await settingsApi.get()).data,
    staleTime: 60_000,
  })

  const handleLogout = async () => {
    await logout()
    toast.info('Du wurdest abgemeldet.')
    navigate('/login', { replace: true })
  }

  return (
    <header className={styles.topbar}>
      <div className={styles.brandMobile}>
        <BrandMark logoUrl={settings?.logoUrl} className={styles.brandMark} />
        <span>{settings?.appName ?? 'NTL Dashboard'}</span>
      </div>
      <div className={styles.actions}>
        <NotificationsDropdown />
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          Abmelden
        </Button>
      </div>
    </header>
  )
}
